export const DRAWER_FAQ_KEY = 'faq'
export const DRAWER_DESIGNATION_KEY = 'designation'
export const DRAWER_DEDICATION_KEY = 'dedication'
export const DRAWER_COMMENT_KEY = 'comment'
export const DRAWER_DOUBLE_THE_DONATION_KEY = 'doubleTheDonation'
export const DRAWER_ORDER_DETAILS_KEY = 'orderDetails'

export type DrawerKey =
  | typeof DRAWER_FAQ_KEY
  | typeof DRAWER_DESIGNATION_KEY
  | typeof DRAWER_DEDICATION_KEY
  | typeof DRAWER_COMMENT_KEY
  | typeof DRAWER_DOUBLE_THE_DONATION_KEY
  | typeof DRAWER_ORDER_DETAILS_KEY

export interface Drawer {
  key: DrawerKey
  label: string
}

export type DrawersMap = { [key: string]: Drawer }

export type DrawerSlice = Drawer | null
